export default [
  {
    path: '',
    name: 'product list',
    component: () => import('@/views/app/product/list/page-list.vue'),
    meta: { title: 'Daftar Produk' },
  },
  {
    path: 'baru',
    name: 'product create',
    component: () => import('@/views/app/product/create/page-create.vue'),
    meta: { title: 'Tambah Produk' },
  },
  {
    path: 'edit/:id',
    name: 'product edit',
    component: () => import('@/views/app/product/edit/page-edit.vue'),
    meta: { title: 'Ubah Informasi Produk' },
  },
  {
    path: ':id',
    name: 'product detail',
    component: () => import('@/views/app/product/detail/page-detail.vue'),
    meta: { title: 'Detail Informasi Produk' },
  },
]
